import { Component, Input, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { AccountsService } from '../../services/account.service';
import { Location } from '@angular/common';

@Component({
  selector: 'app-custom-header',
  templateUrl: './custom-header.component.html',
  styleUrls: ['./custom-header.component.scss'],
})
export class CustomHeaderComponent implements OnInit {
  @Input() headerText = 'Default Header';
  showSideNav=true;
  isLoggedIn=false;
  backColor?:string|null='';
  foreColor?:string|null='';

  constructor( 
    private accountService: AccountsService, 
    public router: Router,
    private location: Location,
  ) {

  }

  ngOnInit(): void {
    this.accountService.userStream.subscribe(res=>{
      if(res){
        this.isLoggedIn=true;
      }
    })
    this.backColor= this.accountService.getBackColor();
    this.foreColor= this.accountService.getForeColor();
  }

  toggleSidenav(): void {
    this.accountService.setToggleSideNav();
  }

  async goToLogin() {
    return this.router.navigate(['/login']);
  }
  async goToUserEdit() {
    const id= localStorage.getItem("userId")
    // return this.router.navigate([`/pages/users/edit/${id}`]);
    this.router.navigate(['pages/users/profile'], { queryParams: { id : id } });
  }
  async logout(){
    await window.localStorage.clear();
    localStorage.removeItem('userName');
    localStorage.removeItem('userId');
    localStorage.removeItem('profileName');
    localStorage.removeItem('authToken');
    localStorage.removeItem('roles');
    localStorage.removeItem('permissions');
    this.accountService.RefreshMemory();
    return this.router.navigate(['/login']);
  }
  async goBack() {
    await this.location.back();
  }

  
  
}
